<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-2">
            <div>
              <h2 class="text-h4 font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-file-document-check-outline</v-icon
                >
                สรุปผลการรายงานตัวการย้าย
              </h2>
              <div class="subtitle-1 grey--text text--darken-1 mt-1">
                ติดตามสถานะการรายงานตัวและผลการประมวลผลการย้าย รอบ
                {{ periods.period_times }}/{{ periods.period_year }}
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #1976D2"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="blue lighten-5" size="60">
                <v-icon color="blue" x-large>mdi-format-list-bulleted</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #4CAF50"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายงานตัวแล้ว (ปกติ)</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.reported }}
                </div>
              </div>
              <v-avatar color="green lighten-5" size="60">
                <v-icon color="success" x-large>mdi-account-check</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #FF9800"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ไม่มารายงานตัว</div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.not_reported }}
                </div>
              </div>
              <v-avatar color="orange lighten-5" size="60">
                <v-icon color="warning" x-large>mdi-account-alert</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #F44336"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ยกเลิก/รอดำเนินการ</div>
                <div class="text-h4 font-weight-bold error--text">
                  {{ stats.issues }}
                </div>
              </div>
              <v-avatar color="red lighten-5" size="60">
                <v-icon color="error" x-large>mdi-file-cancel</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg mb-4">
        <v-toolbar flat color="white" class="pt-2">
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา ชื่อ, วิทยาลัย, หรือรหัส..."
                single-line
                hide-details
                outlined
                dense
                rounded
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="times_select"
                :items="time_ss"
                label="ครั้งที่"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="years_select"
                :items="year_ss"
                label="ปีงบประมาณ"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                block
                rounded
                depressed
                @click="searchTimeYear"
              >
                <v-icon left>mdi-filter</v-icon> ค้นหา
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="success"
                outlined
                block
                rounded
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> Export
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-expansion-panels flat accordion class="mt-2">
          <v-expansion-panel>
            <v-expansion-panel-header class="grey lighten-4">
              <span class="text-subtitle-2 grey--text text--darken-2">
                <v-icon small class="mr-2">mdi-table-cog</v-icon>
                ปรับแต่งคอลัมน์ตาราง
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <v-select
                v-model="selectedHeaders"
                :items="headersMap"
                label="เลือกคอลัมน์ที่ต้องการแสดง"
                multiple
                outlined
                dense
                chips
                small-chips
                deletable-chips
                return-object
              ></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-card elevation="2" class="rounded-lg">
        <v-data-table
          :headers="showHeaders"
          :items="conditons_transfer_successs"
          :search="search"
          :loading="loading"
          :item-class="row_classes"
          class="elevation-0"
          :items-per-page="10"
        >
          <template v-slot:item.cts_report="{ item }">
            <div v-if="item.cts_college_cc === 'CC'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    color="red lighten-1"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="cancelmvTeach(item.id_cts)"
                  >
                    <v-icon left small>mdi-close-circle</v-icon> ขอยกเลิก
                  </v-btn>
                </template>
                <span>คลิกเพื่อดำเนินการยกเลิก</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-chip
                v-if="item.cts_report === 'nb'"
                color="success"
                small
                label
              >
                <v-icon left small>mdi-check</v-icon> รายงานตัวแล้ว
              </v-chip>
              <v-chip
                v-else-if="item.cts_report === 'dnb'"
                color="warning"
                small
                label
              >
                <v-icon left small>mdi-alert</v-icon> ไม่มารายงานตัว
              </v-chip>
              <v-chip v-else color="grey lighten-1" dark small label>
                รอดำเนินการ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.cts_datetime="{ item }">
            <div
              v-if="item.cts_report === 'nb'"
              class="primary--text font-weight-bold"
            >
              {{
                item.cts_datetime
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
            </div>
            <div v-else class="grey--text text-caption">-</div>
          </template>

          <template v-slot:item.cts_files="{ item }">
            <v-btn
              v-if="item.cts_report === 'nb'"
              icon
              color="primary"
              :href="'/HRvecfiles/' + item.cts_files"
              target="_blank"
            >
              <v-icon>mdi-file-download</v-icon>
            </v-btn>
            <v-icon v-else color="grey lighten-2">mdi-file-hidden</v-icon>
          </template>

          <template v-slot:item.college_name_old="{ item }">
            <span class="grey--text text--darken-2">{{
              item.college_name_old
            }}</span>
          </template>
          <template v-slot:item.college_name_new="{ item }">
            <div class="d-flex align-center">
              <v-icon small color="blue" class="mr-1"
                >mdi-arrow-right-bold</v-icon
              >
              <span class="blue--text font-weight-bold">{{
                item.college_name_new
              }}</span>
            </div>
          </template>

          <template v-slot:item.ctsstatus_select="{ item }">
            <v-chip :color="getStatusColor(item.ctsstatus_select)" dark x-small>
              {{ getStatusText(item.ctsstatus_select) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="canceldialog" persistent max-width="700px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="red lighten-1" dark flat>
            <v-icon class="mr-2">mdi-alert-circle</v-icon> ยืนยันการยกเลิกรายการ
            <v-spacer></v-spacer>
            <v-btn icon @click="canceldialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-form ref="cancelform" lazy-validation>
              <v-alert border="left" colored-border type="error" elevation="2">
                คุณกำลังจะลบข้อมูลผลสำเร็จของการย้าย โปรดตรวจสอบความถูกต้อง
              </v-alert>

              <v-card outlined class="pa-4 mt-3">
                <div class="text-h6 mb-2">ข้อมูลบุคลากร</div>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold grey--text">ชื่อ-สกุล</td>
                      <td>
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold grey--text">
                        รหัสบัตรประชาชน
                      </td>
                      <td>{{ transference_personnels_id_ref.id_card }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-form>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="canceldialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="red"
              dark
              elevation="2"
              @click="
                conditons_transfer_successsSelect.ctsstatus_select ===
                'transfer'
                  ? cancelCutSubmit()
                  : cancelSubmit()
              "
            >
              <v-icon left>mdi-delete</v-icon> ยืนยันการลบ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2" dark>{{ snackbar.icon }}</v-icon>
        <span class="white--text">{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snackbar.show = false"
          >ปิด</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // Requires npm install xlsx
import { saveAs } from "file-saver"; // Requires npm install file-saver
import { logSensitiveAccess } from "@/utils/sensitiveAccessLog";

export default {
  name: "TransferReportMV",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",

      // Selectors
      times_select: "",
      years_select: "",
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],

      // Dialogs
      canceldialog: false,

      // Data
      conditons_transfer_successs: [],
      periods: {},
      transference_personnels_id_ref: {},
      conditons_transfer_successsSelect: {},
      man_powerss: {},
      man_powerCan: {},
      man_power_cancel: {},
      conditons_transfer_successs_teach: [],

      // Table Config
      selectedHeaders: [],
      headersMap: [
        {
          text: "สถานะรายงานตัว",
          align: "center",
          value: "cts_report",
          width: "150px"
        },
        { text: "วันที่", align: "center", value: "cts_datetime" },
        { text: "เอกสาร", align: "center", value: "cts_files" },
        { text: "สังกัดใหม่", align: "left", value: "college_name_new" },
        { text: "เลขที่ตำแหน่งใหม่", align: "center", value: "ctsid_position" },
        {
          text: "คำนำหน้าชื่อ",
          align: "left",
          value: "title_s",
          sortable: false
        }, 
        { text: "ชื่อ", align: "left", value: "frist_name" },
        { text: "นามสกุล", align: "left", value: "last_name" },
        
        { text: "สังกัดเดิม", align: "left", value: "college_name_old" },
        { text: "ประเภทการย้าย", align: "center", value: "ctsstatus_select" },
        { text: "ครั้งที่", align: "center", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" }
      ],

      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      }
    };
  },
  computed: {
    showHeaders() {
      return this.headersMap.filter(h => this.selectedHeaders.includes(h));
    },
    stats() {
      const total = this.conditons_transfer_successs.length;
      const reported = this.conditons_transfer_successs.filter(
        i => i.cts_report === "nb"
      ).length;
      const not_reported = this.conditons_transfer_successs.filter(
        i => i.cts_report === "dnb"
      ).length;
      const issues = total - reported - not_reported; // Cancelled or Pending

      return { total, reported, not_reported, issues };
    }
  },
  created() {
    // Set default visible headers
    const defaultKeys = [
      "cts_report",
      "cts_datetime",
      "cts_files",
      "college_name_new",
      "title_s",
      "frist_name",
      "last_name",
      "college_name_old",
      "ctsstatus_select"
    ];
    this.selectedHeaders = this.headersMap.filter(h =>
      defaultKeys.includes(h.value)
    );
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_successQueryAll();
    logSensitiveAccess(
      this.$http,
      "conditons_transfer_success_reportmv",
      "view",
      `รอบ ${this.times_select}/${this.years_select}`
    );
  },
  methods: {
    // --- Data Fetching ---
    async periodQuery() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_type: "teacher"
        });
        this.periods = result.data;
        // Auto select current if available
        if (this.periods.period_times)
          this.times_select = this.periods.period_times;
        if (this.periods.period_year)
          this.years_select = this.periods.period_year;
      } catch (e) {
        console.error("Period Error", e);
      }
    },

    async conditons_transfer_successQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.periods.period_times,
          ctsyear_s: this.periods.period_year
        });
        this.conditons_transfer_successs = result.data;
      } catch (e) {
        this.showSnackbar("error", "โหลดข้อมูลไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    async searchTimeYear() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.times_select,
          ctsyear_s: this.years_select
        });
        this.conditons_transfer_successs = result.data;
        this.showSnackbar("success", `พบข้อมูล ${result.data.length} รายการ`);
      } catch (e) {
        this.showSnackbar("error", "ค้นหาล้มเหลว");
      } finally {
        this.loading = false;
      }
    },

    // --- Actions ---
    async cancelmvTeach(id_cts) {
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          id_cts: id_cts
        });
        this.conditons_transfer_successs_teach = result.data;

        const confirm = await Swal.fire({
          title: "ยืนยันการยกเลิกรายการ?",
          text: `ชื่อ: ${this.conditons_transfer_successs_teach.full_name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          confirmButtonText: "ยืนยันลบ",
          cancelButtonText: "ยกเลิก"
        });

        if (confirm.isConfirmed) {
          // 1. Delete File if exists
          if (this.conditons_transfer_successs_teach.cts_files) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename:
                "../HRvecfiles/" +
                this.conditons_transfer_successs_teach.cts_files
            });
          }

          // 2. Clear Data
          this.conditons_transfer_successs_teach.ApiKey = this.ApiKey;
          this.conditons_transfer_successs_teach.cts_report = "";
          this.conditons_transfer_successs_teach.cts_datetime = "";
          this.conditons_transfer_successs_teach.cts_files = "";
          this.conditons_transfer_successs_teach.cts_college_cc = "";

          // 3. Update DB
          let resUpdate = await this.$http.post(
            "conditons_transfer_success.update.php",
            this.conditons_transfer_successs_teach
          );

          if (resUpdate.data.status === true) {
            Swal.fire("สำเร็จ", "ยกเลิกข้อมูลเรียบร้อย", "success");
            await this.conditons_transfer_successQueryAll();
          } else {
            Swal.fire("ผิดพลาด", "ไม่สามารถอัปเดตข้อมูลได้", "error");
          }
        }
      } catch (e) {
        console.error(e);
        Swal.fire("Error", "เกิดข้อผิดพลาดในการเชื่อมต่อ", "error");
      }
    },

    // Legacy Cancel Logic (Delete entirely)
    async CencelMovement(id_ref) {
      /* ... Logic similar to original but cleaned up ... */

      // Keeping structure for safety if user relies on specific modal flow
      this.loading = true;
      try {
        let res_person = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels_id_ref = res_person.data;

        let res_man = await this.$http.post("man_power.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels_id_ref.id_card
        });
        this.man_powerss = res_man.data;

        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successsSelect = res_cts.data;

        this.canceldialog = true;
      } finally {
        this.loading = false;
      }
    },
    async CencelMovementCut(id_ref) {
      this.loading = true;
      try {
        let res_person = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels_id_ref = res_person.data;

        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successsSelect = res_cts.data;

        this.canceldialog = true;
      } finally {
        this.loading = false;
      }
    },
    async cancelSubmit() {
      // ... Logic for restoring manpower and deleting success record ...
      try {
        // 1. Restore Manpower (if needed)
        this.man_powerCan.ApiKey = this.ApiKey;
        this.man_powerCan.status_booking = "";
        this.man_powerCan.id_position = this.man_powerss.id_position;

        this.man_power_cancel.ApiKey = this.ApiKey;
        this.man_power_cancel.id_position = this.conditons_transfer_successsSelect.ctsid_postion_old;

        if (this.man_powerss) {
          await this.$http.post(
            "man_power.update_process.php",
            this.man_powerCan
          );
        }
        await this.$http.post("man_power.delete.php", this.man_power_cancel);

        // 2. Delete Record
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let res = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (res.data.status == true) {
          this.showSnackbar("success", "ลบข้อมูลเรียบร้อย");
          this.canceldialog = false;
          this.conditons_transfer_successQueryAll();
        }
      } catch (e) {
        this.showSnackbar("error", "Error processing request");
      }
    },
    async cancelCutSubmit() {
      try {
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let res = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );
        if (res.data.status == true) {
          this.showSnackbar("success", "ลบข้อมูลเรียบร้อย");
          this.canceldialog = false;
          this.conditons_transfer_successQueryAll();
        }
      } catch (e) {
        this.showSnackbar("error", "Error processing request");
      }
    },

    // --- Utilities ---
    exportToExcel() {
      const filename = `Report_Movement_${this.years_select}_${this.times_select}.xlsx`;
      logSensitiveAccess(
        this.$http,
        "conditons_transfer_success_reportmv",
        "export",
        filename
      );

      const exportData = this.conditons_transfer_successs.map(item => ({
        สถานะรายงานตัว:
          item.cts_report === "nb"
            ? "รายงานตัวแล้ว"
            : item.cts_report === "dnb"
            ? "ไม่มา"
            : "รอ",
        วันที่รายงานตัว: item.cts_datetime,
        "ชื่อ-สกุล": `${item.title_s}${item.frist_name} ${item.last_name}`,
        สังกัดเดิม: item.college_name_old,
        สังกัดใหม่: item.college_name_new,
        ประเภทการย้าย: this.getStatusText(item.ctsstatus_select),
        "ปี/ครั้งที่": `${item.ctsyear_s}/${item.ctstime_s}`
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report_MV");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(data, filename);
    },

    getStatusText(status) {
      const map = {
        demand: "ว.ประสงค์รับ",
        agree: "ปกติ",
        transfer: "ตัดโอน",
        sw_normal: "สับเปลี่ยน",
        sw_agree: "สับเปลี่ยน(แลกเปลี่ยน)"
      };
      return map[status] || status;
    },
    getStatusColor(status) {
      if (status === "transfer") return "orange";
      if (status === "agree") return "green";
      if (status === "demand") return "blue";
      return "cyan";
    },

    row_classes(item) {
      if (item.ctsstatus_select == "transfer") return "grey lighten-4";
      return "";
    },

    showSnackbar(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.icon =
        color === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
/* Custom Table overrides if needed */
</style>
